module.exports = __webpack_public_path__ + "static/media/human-advantage-logo-dark.5986f99d.png";